import CompanyPropertyEditContent from "../../features/companyProperties/widgets/CompanyPropertyEditContent";

function CompanyPropertyEditScreen() {
  return <CompanyPropertyEditContent />;
}

export default CompanyPropertyEditScreen;
